export default __webpack_public_path__ + "static/media/presented.b61d4066.svg";